import { createContext, useContext } from 'react'

import { ContextType } from './GeneralOcrTableRefContextProvider'

export const GeneralOcrTableContext = createContext<React.RefObject<ContextType>>({
  current: [],
})

export function useGeneralOcrTableContext() {
  return useContext(GeneralOcrTableContext)
}
